<app-metformin
  htmlTitle="<strong>Important: Enhance</strong> Fat Loss, Energy, and Metabolic Control"
  question="We strongly recommend including Metformin in your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Many men using ED medication also struggle with low energy, weight gain, or metabolic issues that can affect
    circulation and performance. Fortunately, there’s a trusted solution: <strong>Metformin</strong>.
  </p>
  <p class="mb-4">
    By adding <strong>Metformin</strong> to your treatment plan, you can support healthier blood sugar control, improved
    metabolism, and steadier energy—benefits that often translate to better circulation and more consistent performance.
  </p>
  <p class="mb-4">
    Metformin is a <strong>safe, well-studied medication</strong> with decades of use and an excellent safety profile.
  </p>
</app-metformin>
